import { useParams } from 'react-router-dom';
import SemanticPageDocument from '@/components/semantic/SemanticPageDocument';
import { getDocsConceptPage } from '@/lib/semantic-content/pages';
import NotFound from '@/pages/NotFound';

export default function DocsConceptPage() {
  const { conceptSlug = '' } = useParams();
  const page = getDocsConceptPage(conceptSlug);

  return page ? <SemanticPageDocument page={page} /> : <NotFound />;
}
